class PixelRatio {
  name: string;
  value: number;
  constructor(name: string, value: number) {
    this.name = name;
    this.value = value;
  }
  toString() {
    return this.name;
  }
}

export const PIXEL_RATIO_HIGH = new PixelRatio('High', 1);
export const PIXEL_RATIO_MID = new PixelRatio('Medium', 0.5);
export const PIXEL_RATIO_LOW = new PixelRatio('Low', 0.25);

export const PIXEL_RATIO_ALL: PixelRatio[] = [
  PIXEL_RATIO_HIGH,
  PIXEL_RATIO_MID,
  PIXEL_RATIO_LOW
];

export default PixelRatio;



// WEBPACK FOOTER //
// ./src/data/PixelRatio.ts